import React from "react";
import { redbrickbg, onair } from "../../assets";

const Brickwall = () => {
  return (
    <div>
      <div>
        <img src={redbrickbg} alt="redbrickbg" />
      </div>
      <div
        className="w-[1200px] 2xl:w-[900px] xl:w-[700px] lg:w-[500px] md:w-[350px] h-auto animate-pulse flex justify-center items-center
    absolute top-[1500px] 2xl:top-[1250px] xl:top-[1350px] md:top-[550px] right-0  md:right-56 sm:right-10 cursor-pointer shadow-xl shadow-red-600"
      >
        <div>
          <img src={onair} alt="onair" />
        </div>
      </div>
    </div>
  );
};

export default Brickwall;
